module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAq0lEQVRIS2NkIAKITv1v84+BYQlIKRMDQ8zrbMYjhLQxElIAkhea+v8gIwODHYj9n4Hh0LtsRntC+ogyWHjq/ysMDAzaUMOuvs1m1Bk1GBQCo0FBYqoAJf6/DAytjAwMwniSkAoDAwM7VP4nAwPDHVxq/zMwvGVmYKhmFJ76/wEDA4M8oXRJovxD2hksOu2/7d//DC1UDwpivDiapeGhNBoUtA8KmlVN5FSmAAiode9CQxcKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/circle/icon_14.png
// module id = x634
// module chunks = 1